/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Last_Bill_Plan_LabelInputs */

const es_admin_billing_last_bill_plan_label = /** @type {(inputs: Admin_Billing_Last_Bill_Plan_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const en_admin_billing_last_bill_plan_label = /** @type {(inputs: Admin_Billing_Last_Bill_Plan_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Admin_Billing_Last_Bill_Plan_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_last_bill_plan_label = /** @type {((inputs?: Admin_Billing_Last_Bill_Plan_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Last_Bill_Plan_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_last_bill_plan_label(inputs)
	return en_admin_billing_last_bill_plan_label(inputs)
});
export { admin_billing_last_bill_plan_label as "admin.billing.last_bill.plan_label" }